import React, { useMemo } from 'react';
import ProductList from '../components/ProductList';
import SearchResults from '../components/SearchResults';
import Combos from '../components/Combos';
import SocialMedia from '../components/SocialMedia';
import RecomendadosList from '../components/RecomendadosList';

const misCategorias = [
  "Higado siempre sano",
  "Defensas al 100",
  "Energía todo el día",
  "Tu peso ideal",
  "Muévete sin dolor",
  "Salud masculina",
  "Bienestar Femenino",
  "Adiós Estrés",
  "Descanso total",
  "Joven por siempre",
  "Reset Natural",
  "Corazón imparable",
  "Huesos siempre fuertes",
  "Inflamación cero",
  "Modo Fitness",
  "Mente al máximo",
  "Vitalidad todos los dias",
];

const nombresVisuales = {
  "Higado siempre sano":    "Salud hepática y detox",
  "Defensas al 100":        "Sistema inmunológico",
  "Energía todo el día":    "Energía y rendimiento",
  "Tu peso ideal":          "Control de peso",
  "Muévete sin dolor":      "Salud articular",
  "Salud masculina":        "Salud masculina",
  "Bienestar Femenino":     "Bienestar femenino",
  "Adiós Estrés":           "Manejo del estrés",
  "Descanso total":         "Calidad del sueño",
  "Joven por siempre":      "Antiedad y colágeno",
  "Reset Natural":          "Salud digestiva",
  "Corazón imparable":      "Salud cardiovascular",
  "Huesos siempre fuertes": "Huesos y calcio",
  "Inflamación cero":       "Control de la inflamación",
  "Modo Fitness":           "Rendimiento deportivo",
  "Mente al máximo":        "Memoria y concentración",
  "Vitalidad todos los dias": "Multivitamínicos",
};

// Barajado aleatorio para rotar el orden de las secciones en cada entrada al Home
const barajarArray = (array) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

const Home = ({ searchQuery, setSearchQuery, addToCart, vistaAfiliado = false }) => {
  const hayBusqueda = searchQuery && searchQuery !== '';

  // Rotación inteligente: barajar las categorías cada vez que se entra al Home
  const categoriasRotadas = useMemo(() => {
    return barajarArray(misCategorias);
  }, []);

  return (
    <main style={{
      backgroundColor: 'var(--bg-page)',
      minHeight: '100vh',
      overflowX: 'hidden',
      fontFamily: 'var(--font-body)',
      color: 'var(--text-primary)',
    }}>

      {/* ── Vista principal ─────────────────────────────────────────── */}
      {!hayBusqueda ? (
        <div style={{
          maxWidth: 'var(--max-width)',
          margin: '0 auto',
          padding: '0 var(--pad-section-x)',
        }}>

          {/* Recomendados: rotación aleatoria de productos */}
          <section style={{ margin: 'var(--space-3) 0 var(--space-5)' }}>
            <RecomendadosList
              addToCart={addToCart}
              onVerTodo={() => setSearchQuery('Recomendados')}
              vistaAfiliado={vistaAfiliado}
            />
          </section>

          {/* Combos del mes: ancla promocional fija */}
          <section id="seccion-combos" style={{ margin: '0 0 var(--space-5)' }}>
            <Combos addToCart={addToCart} />
          </section>

          {/* Categorías con orden rotativo inteligente */}
          {categoriasRotadas.map((cat) => (
            <section key={cat} style={{ margin: '0 0 var(--space-5)' }}>
              <ProductList
                categoriaBusqueda={cat}
                tituloMostrar={nombresVisuales[cat]}
                addToCart={addToCart}
                onVerTodo={setSearchQuery}
                vistaAfiliado={vistaAfiliado}
              />
            </section>
          ))}

        </div>

      ) : (

        /* ── Vista de resultados ──────────────────────────────────── */
        <div style={{
          maxWidth: 'var(--max-width)',
          margin: 'var(--space-5) auto',
          padding: '0 var(--pad-section-x)',
        }}>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 'var(--space-3)',
            borderBottom: '1px solid var(--border-default)',
            paddingBottom: 'var(--space-3)',
            marginBottom: 'var(--space-5)',
          }}>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'var(--font-size-h3)',
              fontWeight: 'var(--font-weight-black)',
              color: 'var(--text-primary)',
              letterSpacing: 'var(--letter-spacing-tight)',
              margin: 0,
            }}>
              Coincidencia inteligente
            </h2>

            <button
              onClick={() => setSearchQuery('')}
              style={{
                backgroundColor: 'var(--bg-card)',
                color: 'var(--text-muted)',
                border: '1px solid var(--border-default)',
                padding: 'var(--pad-btn-sm)',
                borderRadius: 'var(--radius-md)',
                cursor: 'pointer',
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--font-size-small)',
                fontWeight: 'var(--font-weight-medium)',
                transition: 'background-color var(--transition-fast), color var(--transition-fast)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--color-gris-fondo)';
                e.currentTarget.style.color = 'var(--text-primary)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--bg-card)';
                e.currentTarget.style.color = 'var(--text-muted)';
              }}
            >
              Borrar búsqueda
            </button>
          </div>

          <SearchResults queryTexto={searchQuery} addToCart={addToCart} setSearchQuery={setSearchQuery} />
        </div>
      )}

      <SocialMedia />
    </main>
  );
};

export default Home;
